import { render, staticRenderFns } from "./SuperAdminCode.vue?vue&type=template&id=1af749cf"
import script from "./SuperAdminCode.vue?vue&type=script&lang=js"
export * from "./SuperAdminCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports